<template>
  <span
    :class="['custom-checkbox', { active: value }]"
    role="checkbox"
    tabindex="0"
    :aria-checked="value === 'intermediate' ? 'mixed' : String(Boolean(value))"
    :aria-label="label"
    @keydown.space.prevent="$el.click()"
  >
    <feather-icon
      v-if="value"
      color="white"
      :icon="value === 'intermediate' ? 'MinusIcon' : 'CheckIcon'"
      size="14"
      :style="headerStyle"
    />
  </span>
</template>
<script>
export default {
  name: 'CustomCheckbox',
  props: { value: { type: [Boolean, String], default: false }, header: Boolean, label: { type: String, default: '' } },
  computed: {
    headerStyle() {
      return {
        position: 'relative',
        top: this.header ? '0' : '-2px',
      }
    },
  },
}
</script>
<style lang="scss">
.custom-checkbox {
  border: 1px solid #d6d3d3;
  width: 18px;
  height: 18px;
  background: white;
  display: inline-block;
  border-radius: 3px;
  overflow: hidden;
  cursor: pointer;
  text-align: center;
  svg {
    position: relative;
    color:white;
  }
  &.active {
    background: #007bff;
  }
}
</style>
